import store from '~/redux/user/store'
import { getPinInSession } from '~/views/Popup/views/PinOverlay/setPinInSession'

export const isPinSet = () => {

  // 1. check user parental control window setting enabled or not
  if(window.settings.features && window.settings.features.parental_control){
    const user = store.getState().user;
    // 2. check user login
    if(user) {
      // 3. check parental control toggle set
      if(isParentalControlSet()) {
        const parentalPin = user && user.parentalControl && user.parentalControl.parentalPin;
        // 4. check parental control pin set
        if(parentalPin) {
          // 5. check parental control pin session set
          const getUserPin = user.parentalControl.parentalPin;
          if(getPinInSession(user) == getUserPin) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return false
  }
}


export const isParentalControlSet = () => {
  const user = store.getState().user
  return user && user.parentalControl && user.parentalControl.parentalControl ? user.parentalControl.parentalControl: false;
}

export const getUserPin = () => {
  const user = store.getState().user;
  const getPin = user && user.parentalControl && user.parentalControl.parentalPin;
  
  return getPin ? getPin : '';
}

export const isParentalRatingSet = () => {
  const user = store.getState().user
  return user && user.parentalControl && user.parentalControl.parentalRating ? user.parentalControl.parentalRating: false;
}